import { render } from "./HelpCenterContent.vue?vue&type=template&id=a273441a"
import script from "./HelpCenterContent.vue?vue&type=script&lang=js"
export * from "./HelpCenterContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.38_vue@3.2.13_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__